﻿import { capacity_capacity } from "./capacity_capacity";

export class capacity {
    public capacities: capacity_capacity[] = [];
}